import type { SessionView } from '~/helpers/learner/session-view'
import { Award } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { certificateNotice } from '~/helpers/learner/certificate-notice'

/** Ce qu'il manque pour obtenir l'attestation (#10), à la place du bouton — ou rien. */
function CertificateLockNotice({ session }: { session: SessionView }) {
  const { t } = useTranslation()
  const notice = certificateNotice(session)
  if (!notice) return null

  return (
    <p className="flex items-start gap-1.5 text-xs text-muted-foreground">
      <Award className="mt-0.5 size-3.5 shrink-0" />
      {t(notice.key, notice.values)}
    </p>
  )
}

export default CertificateLockNotice
